import env from './env';

const { name, version, isChromiumEdge } = env;

export default (isChromiumEdge || (name === 'Chrome' && version >= 72) ||
  (name === 'Samsung' && version >= 14) ||
  (name === 'Firefox' && version >= 66) || (name === 'Opera' && version >= 60))
  || (name === 'Safari');
